export default __webpack_public_path__ + "static/media/banner_video.7a26f7f0.png";